// // reducer.js
import {
	POST_FEEDBACK_REQUEST,
	POST_FEEDBACK_SUCCESS,
	POST_FEEDBACK_FAILURE,
  } from './feedback.action.js';
  
  const initialState = {
	loading: false,
	success: false,
	error: null,
  };
  
  const feedbackReducer = (state = initialState, action) => {
	switch (action.type) {
	  case POST_FEEDBACK_REQUEST:
		return { ...state, loading: true, success: false, error: null };
	  case POST_FEEDBACK_SUCCESS:
		return { ...state, loading: false, success: true, error: null };
	  case POST_FEEDBACK_FAILURE:
		return { ...state, loading: false, success: false, error: action.payload };
	  default:
		return state;
	}
  };
  
  export default feedbackReducer;